import settingRoutes from '../modules/settings';
// import dashboardRoutes from '../modules/dashboard';
import authRoutes from '../modules/auth';
import userRoutes from '../modules/users';
// import templateRoutes from '../modules/templates';
import documentRoutes from '../modules/documents';
import reportRoutes from '../modules/report';
import scanRoutes from '../modules/scan';
import dashboardRoutes from '../modules/dashboard';

// flatten the list of all nested routes
const flattenRoutes = routes => {
    let flatRoutes = [];

    routes = routes || [];

    routes.forEach(item => {
        flatRoutes.push(item);
        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const allRoutes = [
    dashboardRoutes,
    reportRoutes,
    authRoutes,
    documentRoutes,
    scanRoutes,
    // templateRoutes,
    // batchRoutes,
    userRoutes,
    settingRoutes,
    // folderRoutes,
];

const authProtectedRoutes = [
    dashboardRoutes,
    reportRoutes,
    documentRoutes,
    scanRoutes,
    // templateRoutes,
    // batchRoutes,
    userRoutes,
    settingRoutes,
    // folderRoutes,
];

const allFlattenRoutes = flattenRoutes(allRoutes);

export {allRoutes, authProtectedRoutes, allFlattenRoutes};
